import React from "react";
import Tables from "src/components/Table/tableData";
import MerchantLayout from "src/components/Layouts/MerchantLayout";
import { IconButton, Grid } from "@mui/material";
import { Edit, Search } from "@mui/icons-material";
import { useNavigate } from "react-router-dom";
import { getProductAddons, ProductAddOnResponse } from "src/redux/productAddon";
import useRedux from "src/redux/useRedux";
import { ToastContainer, toast } from "react-toastify";
import checkPermission from "src/helper/checkPermission";

const ProductAddOnList = () => {
  const navigate = useNavigate();
  const { thunkDispatch } = useRedux();
  const [limit, setLimit] = React.useState(10);
  const [page, setPage] = React.useState(1);
  const [filter, setFilter] = React.useState("");
  const [status, setStatus] = React.useState("true");
  const [loading, setLoading] = React.useState(true);
  const [productAddOns, setProductAddons] =
    React.useState<ProductAddOnResponse>();

  const columns = [
    {
      name: "No",
      selector: (_row: any, index: number) => index + 1,
      sortable: true,
    },
    {
      name: "Nama Produk",
      selector: (row: any) => row.product_name,
      sortable: true,
    },
    {
      name: "Produk Add-On",
      cell: (row: any) => {
        return row.productAddOn && row.productAddOn.length > 0
          ? row.productAddOn
              .map((item: any) => {
                return item.product_name;
              })
              .join(", ")
          : "";
      },
    },
    {
      name: "Aksi",
      center: true,
      cell: (item: any) => {
        return (
          <Grid
            container
            direction="row"
            justifyContent="center"
            alignItems="center"
          >
            {checkPermission("Product Add On", "is_add") && (
              <IconButton
                aria-label="assign"
                color="primary"
                onClick={() => {
                  navigate(`/products/product-addon/${item.product_id}/assign`);
                }}
              >
                <Edit />
              </IconButton>
            )}
            <IconButton
              aria-label="detail"
              color="warning"
              onClick={() => {
                navigate(`/products/product-addon/${item.product_id}/view`);
              }}
            >
              <Search />
            </IconButton>
          </Grid>
        );
      },
    },
  ];

  const fetchProductAddOns = () => {
    setLoading(true);
    thunkDispatch(
      getProductAddons({
        limit: limit,
        offset: page - 1,
        filter: filter ?? "",
      })
    )
      .unwrap()
      .then((res) => {
        if (res && res.status === "success") {
          setLoading(false);
          setProductAddons(res.data);
        }
      });
  };

  React.useEffect(() => {
    fetchProductAddOns();
  }, [limit, page, filter, status]);

  return (
    <MerchantLayout>
      <ToastContainer />
      <Tables
        records={productAddOns?.data ?? []}
        columns={columns}
        title="Produk Add-On"
        isSearch={true}
        onChangeSearch={(e) => setFilter(e.target.value)}
        valueSearch={filter}
        progressPending={loading}
        paginationPerPage={limit}
        totalRow={
          productAddOns && productAddOns.meta && productAddOns.meta.total
            ? productAddOns.meta.total
            : 0
        }
        onChangePage={(page) => setPage(page)}
        onChangeRowsPerPage={(currentRowsPerPage) =>
          setLimit(currentRowsPerPage)
        }
      />
    </MerchantLayout>
  );
};

export default ProductAddOnList;
